import { render, staticRenderFns } from "./OnePageMain.vue?vue&type=template&id=6ac9f802&scoped=true&"
import script from "./OnePageMain.vue?vue&type=script&lang=js&"
export * from "./OnePageMain.vue?vue&type=script&lang=js&"
import style0 from "./OnePageMain.vue?vue&type=style&index=0&id=6ac9f802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac9f802",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac9f802')) {
      api.createRecord('6ac9f802', component.options)
    } else {
      api.reload('6ac9f802', component.options)
    }
    module.hot.accept("./OnePageMain.vue?vue&type=template&id=6ac9f802&scoped=true&", function () {
      api.rerender('6ac9f802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/OnePageMain.vue"
export default component.exports